import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ListTodo, Clock, FileText } from 'lucide-react';

const EmployeeTasks = ({ tasks = [], onToggleStatus }) => {
  const navigate = useNavigate();
  const priorityColors = {
    low: 'bg-blue-100 text-blue-800',
    medium: 'bg-yellow-100 text-yellow-800',
    high: 'bg-orange-100 text-orange-800',
    urgent: 'bg-red-100 text-red-800'
  };
  const priorityLabels = { low: 'Faible', medium: 'Moyenne', high: 'Haute', urgent: 'Urgente' };

  return (
    <Card className="border-0 shadow-xl bg-gradient-to-br from-orange-50 to-red-50">
      <CardHeader>
        <div className="flex justify-between items-center">
          <CardTitle className="flex items-center gap-2 text-2xl">
            <ListTodo className="h-7 w-7 text-orange-600" />Mes Taches Assignees
          </CardTitle>
          <div className="text-right">
            <div className="text-3xl font-bold text-orange-600">{tasks.filter(t => t.status !== 'termine').length}</div>
            <p className="text-sm text-gray-600">tache(s) en cours</p>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {tasks.length > 0 ? tasks.map((task) => {
            const done = task.status === 'termine';
            return (
              <Card key={task.id} className={`border-2 ${done ? 'border-green-500 bg-green-50' : 'border-orange-200 bg-white'}`}>
                <CardContent className="p-4">
                  <div className="flex items-start gap-4">
                    <input type="checkbox" checked={done} onChange={() => onToggleStatus(task.id, task.status)} className="w-5 h-5 text-green-600 rounded cursor-pointer mt-1" />
                    <div className="flex-1">
                      <div className="flex items-start justify-between mb-2">
                        <h4 className={`font-semibold ${done ? 'text-green-900 line-through' : 'text-gray-900'}`}>{task.title}</h4>
                        <Badge className={priorityColors[task.priority]}>{priorityLabels[task.priority] || task.priority}</Badge>
                      </div>
                      <p className="text-sm text-gray-600 mt-1">{task.description}</p>
                      <div className="flex items-center gap-4 text-sm text-gray-600 mt-2">
                        {task.deadline && <span className="flex items-center gap-1"><Clock className="h-4 w-4" />Echeance: {new Date(task.deadline).toLocaleDateString('fr-FR')}</span>}
                        <span>Assignee par: {task.assigned_by_name}</span>
                        {task.file_id && <Button variant="outline" size="sm" onClick={() => navigate(`/files/${task.file_id}`)} className="ml-auto"><FileText className="h-4 w-4 mr-1" />Voir le dossier</Button>}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          }) : (
            <Card className="border-2 border-dashed border-orange-300 bg-white">
              <CardContent className="p-8 text-center">
                <ListTodo className="h-12 w-12 mx-auto mb-4 text-orange-400 opacity-50" />
                <p className="text-gray-600">Aucune tache ne vous a encore ete assignee.</p>
              </CardContent>
            </Card>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default EmployeeTasks;
